import React, { useEffect } from "react";
import { useNavigate, useLocation, useSearchParams } from "react-router-dom";
// Styles
import { useTheme } from "@mui/material/styles";
import useStyles from "assets/jss/material-react/views/italmundoStyles";
// Components
import PageContainer from "../../components/PageContainer/PageContainer";
import { Grid, Button, useMediaQuery } from "@mui/material";
import { Redireccion } from "../../components/Modals";
// Service
import ClientService from "services/clientService";
import {
  getProductNameById,
  useRedirect,
  URLs,
} from "../../utils/redirectStep";
import { saveSessionTipoTarjetaPlata } from "services/sessionStorageService";

function Oferta() {
  //Inicializaciones base
  const clientService = new ClientService();
  const classes = useStyles();
  const navigate = useNavigate();
  const location = useLocation();
  const theme = useTheme();
  const mobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [searchParams, setSearchParams] = useSearchParams();
  const [loading, setLoading] = React.useState(false);
  const { checkAndRedirect } = useRedirect();
  const [modal, setModal] = React.useState({
    open: false,
    showX: true,
    title: "",
    message: "",
    content: null,
  });

  // Inicializaciones particulares
  const [tarjeta, setTarjeta] = React.useState(null);
  const tipoTarjeta = getProductNameById(tarjeta?.producto.codigoProducto);
  const paraPago =
    tarjeta?.producto.codigoProducto === 1 ||
    tarjeta?.producto.codigoProducto === 2;
  const canonicalUrl = `${URLs.oferta}/${tipoTarjeta}`;
  const buttonClass =
    tipoTarjeta === "plata"
      ? classes.btnTarjPlata
      : tipoTarjeta === "oro" || tipoTarjeta === "oro-mas"
      ? classes.btnTarjOro
      : tipoTarjeta === "platino"
      ? classes.btnTarjPlatino
      : classes.btnTarjPlatinoMas;

  // Modales

  const openModalRedirect = () => {
    setModal({
      open: true,
      showX: false,
      content: <Redireccion />,
    });
  };

  useEffect(() => {
    const params = new URLSearchParams(searchParams);
    checkAndRedirect(openModalRedirect, 3, params.toString());
  }, []);

  useEffect(async () => {
    const fetchData = async () => {
      setTarjeta(location?.state?.userData);
    };
    fetchData();
  }, []);

  // Eventos

  const buildNavigateUrl = (path) => {
    const params = new URLSearchParams(searchParams);
    return `${path}?${params.toString()}`;
  };

  const handleModalCloseClick = () => setModal({ ...modal, open: false });

  const handleLaQuieroClick = async (index) => {
    setLoading(true);
    const formData = {
      codigoProducto: location.state.userData.producto.codigoProducto,
      financialInformation: paraPago
        ? location.state.userData.financialInformation.infoProducto[index]
        : location.state.userData.financialInformation,
    };
    try {
      const response = await clientService.confirmOffer(
        formData,
        location.state.transaction,
      );
      if (response.code == 200) {
        const pagoAnt = paraPago
          ? location.state.userData.financialInformation.infoProducto[index]
              .pagoAnticipado
          : null;
        saveSessionTipoTarjetaPlata(pagoAnt);
        const newTransaction = {
          ...location.state.transaction,
          productName: tipoTarjeta,
          codigoProducto: location.state.userData.producto.codigoProducto,
        };
        if (location.state.userData.requiereDoc === false) {
          navigate(buildNavigateUrl(URLs.agenciaDeRetiro), {
            state: {
              transaction: newTransaction,
              userData: response.data,
            },
          });
        } else {
          navigate(
            buildNavigateUrl(`${URLs.solicitarMiTarjeta}/${tipoTarjeta}`),
            {
              state: {
                transaction: newTransaction,
                userData: response.data,
              },
            },
          );
        }
      } else {
        navigate(buildNavigateUrl(URLs.intenteLuego));
      }
    } catch (error) {
      navigate(buildNavigateUrl(URLs.intenteLuego));
    } finally {
      setLoading(false);
    }
  };

  // Componentes

  const DescripcionTarjeta = () => {
    return (
      <div
        className={
          mobile ? `${classes.parrafoMobileOferta}` : `${classes.parrafo}`
        }
        dangerouslySetInnerHTML={{
          __html: tarjeta && tarjeta.producto.leyendaProducto,
        }}
      />
    );
  };

  const Beneficios = () => {
    return (
      <Grid
        item
        xs={12}
        sm={6}
        display="flex"
        flexDirection="column"
        alignItems="center"
      >
        {tarjeta.producto.beneficios.map((benef, index) => (
          <div
            key={index}
            className={`${classes.parrafoMobile} ${classes.divBeneficios}`}
          >
            <div style={{ alignContent: "space-around" }}>
              <img
                style={{
                  width: "26px",
                  maxHeight: "auto",
                  marginRight: "10px",
                  verticalAlign: "middle",
                }}
                src={benef.icono}
              />
            </div>
            <div dangerouslySetInnerHTML={{ __html: benef.descripcion }} />
          </div>
        ))}
      </Grid>
    );
  };

  const BotonPlata = ({ btn, index }) => {
    return (
      <div
        className={classes.divBtn}
        key={index}
        style={{ textAlign: "center" }}
      >
        <Button
          className={`${classes.btnFull} ${classes.btnTarjPlata2}`}
          onClick={() => handleLaQuieroClick(index)}
          sx={{
            marginTop: "0.5rem",
          }}
        >
          <div style={{ width: "100%", display: "flex" }}>
            <div style={{ width: "60%", paddingLeft: "5px" }}>
              <div className={classes.divBtnTarjetaPlata2}>
                Límite disponible &nbsp;$
                <span className="special-font">{btn.limiteDisponible}</span>
              </div>
              <div className={classes.divBtnTarjetaPlata2}>
                Pago anticipado &nbsp;$
                <span className="special-font">{btn.pagoAnticipado}</span>
              </div>
            </div>
            <div className={classes.divRightBtnTarjetaPlata2}>
              {" "}
              {"LA QUIERO"}
            </div>
          </div>
        </Button>
      </div>
    );
  };

  const BotonLaQuiero = () => {
    return (
      <div
        className={classes.divBtn}
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Button
          className={`${classes.btnFull} ${buttonClass}`}
          onClick={() => handleLaQuieroClick(0)}
          sx={{
            maxWidth: "380px",
            marginTop: mobile ? "0.8rem" : "",
          }}
        >
          {"LA QUIERO"}
        </Button>
      </div>
    );
  };

  const Botonera = () => {
    return (
      <>
        <div
          style={{
            width: "100%",
            justifyItems: "center",
          }}
        >
          <p
            style={{
              fontSize: "11px",
              lineHeight: "1.2",
              maxWidth: "520px",
              textAlign: "center",
              marginTop: "3rem",
              paddingLeft: "1rem",
              paddingRight: "1rem",
              fontStyle: "italic",
            }}
          >
            Todos los cargos incluidos en el estado de cuenta son obligatorios,
            a excepción del envío extraordinario y el cargo por envío del estado
            de cuenta (Circular 2016 BCU). Conocé nuestros costos{" "}
            <a
              href="https://italmundo.com.uy/wp-content/uploads/2025/06/Tasas-de-interes-.docx.pdf"
              target="_blank"
              rel="noopener noreferrer"
            >
              aquí.
            </a>
          </p>
        </div>
        <Grid
          item
          xs={12}
          sm={12}
          display="flex"
          flexDirection={mobile ? "column" : "row"}
          alignItems="center"
          justifyContent="center"
        >
          {tarjeta?.financialInformation?.infoProducto?.length > 1 ? (
            tarjeta.financialInformation.infoProducto.map((btn, index) => (
              <BotonPlata key={index} btn={btn} index={index} />
            ))
          ) : (
            <BotonLaQuiero />
          )}
        </Grid>
      </>
    );
  };

  const ImagenTarjeta = () => {
    return (
      <Grid
        item
        xs={12}
        sm={6}
        display="flex"
        flexDirection="column"
        alignItems="center"
      >
        <img
          style={{
            maxWidth: "95%",
            maxHeight: "100%",
          }}
          src={tarjeta.producto.imgLogo}
        />
      </Grid>
    );
  };

  return (
    <PageContainer
      loading={loading}
      modal={modal}
      handleModalCloseClick={handleModalCloseClick}
      canonicalUrl={canonicalUrl}
      noImage={mobile ? true : false}
    >
      {tarjeta && (
        <>
          <DescripcionTarjeta />
          <Grid container spacing={mobile ? 0 : 3.5}>
            <ImagenTarjeta />
            <Beneficios />
            <Botonera />
          </Grid>
        </>
      )}
    </PageContainer>
  );
}

export default Oferta;
